import { render, staticRenderFns } from "./AdminNotificationCodes.vue?vue&type=template&id=7f2f2ef4&scoped=true&"
import script from "./AdminNotificationCodes.vue?vue&type=script&lang=js&"
export * from "./AdminNotificationCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f2ef4",
  null
  
)

export default component.exports